import React from 'react'
import { Link, useTranslation } from '../../plugins/i18next/ea-react-i18next';


const LegalNav = () => {
    const { t } = useTranslation("components" ,{ keyPrefix: 'privacy' });

    return (
        <div className="widget-area d-print-none">
            <div className="widget widget_insight privacyWidget">
                <h3 className="widget-title">{t("legal")}</h3>
                <ul>
                    <li>
                        <Link to="/legal" activeClassName="active">
                        {t("home")}
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="widget widget_insight privacyWidget">
                <h3 className="widget-title">{t("products")}</h3>
                <ul>
                    <li>
                        <Link to="/legal/terms" activeClassName="active">
                        { t('generalTermsAndConditions')}
                        </Link>
                    </li>
                    <li>
                        <Link to="/legal/dataprocessing" activeClassName="active">
                        {t('dataProcessingAgreement')}
                        </Link>
                    </li>
                    <li>
                        <Link to="/legal/privacy" activeClassName="active">
                        {t('generalPrivacyPolicy')}
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="widget widget_insight privacyWidget">
                <h3 className="widget-title">EasyLife 365 Collaboration</h3>
                <ul>
                    <li>
                        <Link to="/legal/collaboration/terms" activeClassName="active">
                        {t('termsOfUse')}
                        </Link>
                    </li>
                    <li>
                        <Link to="/legal/collaboration/privacy" activeClassName="active">
                        {t('privacyPolicy')}
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="widget widget_insight privacyWidget">
                <h3 className="widget-title">EasyLife 365 Identity</h3>
                <ul>
                    <li>
                        <Link to="/legal/identity/terms" activeClassName="active">
                        {t('termsOfUse')}
                        </Link>
                    </li>
                    <li>
                        <Link to="/legal/identity/privacy" activeClassName="active">
                        {t('privacyPolicy')}
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="widget widget_insight privacyWidget">
                <h3 className="widget-title">EasyLife 365 Mail</h3>
                <ul>
                    <li>
                        <Link to="/legal/mail/terms" activeClassName="active">
                        {t('termsOfUse')}
                        </Link>
                    </li>
                    <li>
                        <Link to="/legal/mail/privacy" activeClassName="active">
                        {t('privacyPolicy')}
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="widget widget_insight privacyWidget">
                <h3 className="widget-title">EasyMeet 365</h3>
                <ul>
                    <li>
                        <Link to="/legal/meet/terms" activeClassName="active">
                        {t('termsOfUse')}
                        </Link>
                    </li>
                    <li>
                        <Link to="/legal/meet/privacy" activeClassName="active">
                        {t('privacyPolicy')}
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="widget widget_insight privacyWidget">
                <h3 className="widget-title">EasyTipster</h3>
                <ul>
                    <li>
                        <Link to="/legal/tipster/terms" activeClassName="active">
                        {t('termsOfUse')}
                        </Link>
                    </li>
                    <li>
                        <Link to="/legal/tipster/privacy" activeClassName="active">
                        {t('privacyPolicy')}
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="widget widget_insight privacyWidget">
                <h3 className="widget-title"> {t('website')}</h3>
                <ul>
                    <li>
                        <Link to="/legal/web/privacy" activeClassName="active">
                        {t('privacyPolicy')}
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default LegalNav